import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { FLEXIBLE_DURATION_RANGE } from 'constants/search'
import React from 'react'
import { useIntl } from 'react-intl'
import DurationPicker, { DurationOption } from './DurationPicker'
import MonthPicker from './MonthPicker'

interface Props {
  onDurationChange?: (duration: FLEXIBLE_DURATION_RANGE) => void
  onMonthChange?: (monthOptions: string) => void
  onDatesChange?: () => void
  previouslySelectedDuration?: FLEXIBLE_DURATION_RANGE
  previouslySelectedMonths?: string
  durationOptionsCustom?: Array<DurationOption>
  showYearSelector?: boolean
}

function FlexibleDatePicker(props: Props) {
  const {
    onDurationChange,
    onMonthChange,
    previouslySelectedDuration,
    previouslySelectedMonths,
    durationOptionsCustom,
    showYearSelector,
  } = props
  const intl = useIntl()
  return (
    <Group direction="vertical" gap={24} horizontalAlign="center">
      <Group direction="vertical" gap={16} horizontalAlign="center">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'xFtiiq0QmR',
            defaultMessage: 'How long?',
            description: 'Heading for duration selection in flexible date picker',
          })}
        </Heading>
        <DurationPicker
          durationOptionsCustom={durationOptionsCustom}
          previouslySelectedDuration={previouslySelectedDuration}
          onDurationChange={onDurationChange}
        />
      </Group>
      <Group direction="vertical" gap={16} horizontalAlign="center">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'YSbyijtgCB',
            defaultMessage: 'When?',
            description: 'Heading for month selection in flexible date picker',
          })}
        </Heading>
        <MonthPicker
          previouslySelectedMonths={previouslySelectedMonths}
          onMonthChange={onMonthChange}
          showYearSelector={showYearSelector}
        />
      </Group>
    </Group>
  )
}

export default FlexibleDatePicker
